// extracted by mini-css-extract-plugin
export var cursor = "mouse-module--cursor--11dc9";